import React, { useState } from "react";
import "react-quill/dist/quill.snow.css";
import { Modal, Box, Typography, TextField, Button } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { ApprovalStatuses } from "../../../constants/Status";
import { withTranslation } from "react-i18next";
import { ProjectTag } from "../../../constants/Common";

const ReasonModal = ({ handleClsoe, open, handleSave, module, action, t }) => {
  const validate = Yup.object().shape({
    reason: Yup.string()
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .max(2000, t("Reason can not be greater than 2000 characters"))
      .required(t("Reason is required")),
  });

  return (
    <React.Fragment>
      <div className="rejectModal">
        <Modal
          open={open}
          onClose={handleClsoe}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="rejectPopupButton rejectModalStyle">
            <Typography
              id="modal-modal-title"
              className="rejectPopHeading"
              variant="h6"
              component="h2"
            >
              {t(`Why do you want to ${action === ProjectTag.INACTIVE ? 'deactivate' : 'stop'} this ${module === 'project' ? 'startup' : module}?`)}
            </Typography>
            <Formik
              initialValues={{
                reason: "",
              }}
              validateOnMount
              validationSchema={validate}
              onSubmit={(values) => {
                handleSave(values.reason);
              }}
            >
              {({ errors, touched, setFieldValue, handleBlur, isValid }) => (
                <Form>
                  <div>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="reason"
                      label={t("Reason")}
                      fullWidth
                      variant="standard"
                      name="reason"
                      onChange={(event) =>
                        setFieldValue("reason", event.target.value)
                      }
                      onBlur={handleBlur}
                    />
                    <div>
                      {touched.reason && errors.reason ? (
                        <div className="messageErrorStyle">
                          {errors.reason}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="projApprovalbtns mt-4">
                    <Button
                      variant="outlined"
                      className="approveBtn mx-2"
                      type="submit"
                      disabled={!isValid}
                    >
                      {action === ProjectTag.INACTIVE ? t('Deactivate') : t('Stop')}
                    </Button>
                    <Button
                      disableElevation
                      variant="contained"
                      className="cancelBttn mx-2"
                      type="reset"
                      onClick={handleClsoe}
                    >
                      {t("Cancel")}
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Box>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(ReasonModal);
